<template>
  <div style="height: 100px">
    <v-chart
      class="chart"
      :option="opts"
      id="time-distribution-container"
      ref="graph"
      :theme="theme"
    />
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LinesChart, LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import "../themes/roma.js";
import "../themes/vintage.js";
import "../themes/dark.js";
import DataService from "../lib/DataService";

use([
  CanvasRenderer,
  LinesChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  LineChart,
]);

export default {
  name: "Charts",
  components: {
    VChart,
  },
  async mounted() {
    this.setTheme();
    this.categoryDistributionOb = await DataService.categoryDistributionOb();
    this.categoryDistributionRe = await DataService.categoryDistributionRe();
    this.opts.xAxis.data = this.categoryDistributionOb["range"];
    this.setGraph();
    let that = this;
    window.onresize = function () {
      that.$refs.graph.resize();
    };
  },
  props: {
    categoriesOb: Array,
    categoriesRe: Array,
    mainTheme: String,
  },
  methods: {
    setTheme() {
      if (this.mainTheme == "dark") {
        this.theme = "dark";
      } else {
        this.theme = "light";
      }
      this.$forceUpdate();
    },
    setGraph() {
      const legend = [];
      const series = [];
      this.$refs.graph.clear();
      this.opts.legend.data = [];
      this.opts.series = [];

      this.categoriesOb.forEach((element) => {
        legend.push(`${element} (obverse)`);
        series.push({
          areaStyle: { opacity: 0.3 },
          data: this.categoryDistributionOb[element]["mean"],
          type: "line",
          smooth: true,
          name: `${element} (obverse)`, // Differentiate by adding "(Re)"
          symbol: "none",
          lineStyle: { opacity: 1 },
        });
      });

      this.categoriesRe.forEach((element) => {
        legend.push(`${element} (reverse)`);
        series.push({
          areaStyle: { opacity: 0.3 },
          data: this.categoryDistributionRe[element]["mean"],
          type: "line",
          smooth: true,
          name: `${element} (reverse)`, // Differentiate by adding "(Re)"
          symbol: "none",
          lineStyle: { opacity: 1 },
        });
      });

      this.opts.legend.data = legend;
      this.opts.series = series;
    },
  },
  watch: {
    mainTheme() {
      this.setTheme();
    },
    categoriesOb() {
      this.setGraph();
    },
    categoriesRe() {
      this.setGraph();
    },
  },
  data() {
    return {
      theme: "light",
      categoryDistributionOb: [],
      categoryDistributionRe: [],
      opts: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          left: 50,
          top: 30,
          right: 50,
          bottom: 5,
        },
        legend: {
          data: [],
          top: 8,
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          position: "right",
        },
        series: [],
      },
    };
  },
};
</script>

<style scoped></style>
